import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IRadioArray } from './radio-button.component.types';

@Component({
    selector: 'gdx-radio-button',
    templateUrl: './radio-button.component.html',
    styles: [],
    standalone: false
})
export class RadioButtonComponent implements OnInit {
  @Input('parentForm') parentForm: UntypedFormGroup = new UntypedFormGroup({});
  @Input('radioGroup') radioGroup: any;
  @Output('onChange') onChange = new EventEmitter();
  radioDirection = '';
  radioAlign = '';
  radioList: IRadioArray[] = [];

  ngOnInit(): void {
    this.radioAlign = this.radioGroup.align;
    this.radioList = this.radioGroup.radioList;
  }

  valueChange(event: any): void {
    this.onChange.emit(event);
  }
}
